import {Component, OnInit} from '@angular/core';
import {CieloService} from '../services/cielo.service';
import {AuthService} from '../services/auth.service';
import {DomSanitizer} from '@angular/platform-browser';

@Component({
  selector: 'app-cielo-lab',
  templateUrl: './cielo-lab.component.html',
  styleUrls: [ './cielo-lab.component.scss' ]
})
export class CieloLabComponent implements OnInit {

  public qrcodeImage: any;
  public qrCodeString: any;
  public link: any;
  public paymentId: any;
  public returnCode: any;
  public status: any;

  constructor (
    public _authService: AuthService,
    public _cieloService: CieloService,
    private sanitizer: DomSanitizer
  ) { }

  ngOnInit () {
  }

  async callCieloPIX () {

    const cardAuthorize: any = {
      "MerchantOrderId": "PIX0000000001",
      "Customer": {
        "Name": "Carlos Alberto Otero",
        "Identity": "03466792819",
        "IdentityType": "CPF"
      },
      "Payment":
      {
        "Type": "Pix",
        "Amount": 100 // in cents
      }
    }

    this._cieloService.callCieloPIX(cardAuthorize)
      .then((ret: any) => {

        const status = ret.data[ 0 ].status;
        const result = ret.data[ 0 ].body

        console.log(JSON.stringify(result))

        console.log(status)

        let imgSource = result.Payment.QrCodeBase64Image
        this.qrcodeImage = this.sanitizer.bypassSecurityTrustResourceUrl(`data:image/png;base64, ${ imgSource }`);

        this.qrCodeString = result.Payment.QrCodeString;
        this.link = result.Payment.Links[ 0 ].Href
        this.paymentId = result.Payment.PaymentId
        this.returnCode = result.Payment.ReturnCode
        this.status = result.Payment.Status

        //console.log("qrCodeString: " + this.qrCodeString)
        //console.log('---------------------------------------------')
        //console.log("qrcodeImage: " + this.qrcodeImage)

      })
      .catch((error) => {
        console.log("erro:: " + error.message)
      })
    /*
    MerchantOrderId
    Customer
        Name
        Identity
        IdentityType
    Payment
        QrCodeBase64Image
        QrCodeString
        Tid
        ProofOfSale
        SentOrderId
        Amount
        ReceivedDate
        Provider
        Status
        IsSplitted
        ReturnMessage
        ReturnCode
        PaymentId
        Type
        Currency
        Country
        Links[]
          Method
          Rel
          Href
      */
  }

  callCieloPIXURI () {

    this._cieloService.callCieloPIXURI(this.link)
      .then((ret: any) => {
        const status = ret.data[ 0 ].status;
        const result = ret.data[ 0 ].body

        console.log('statusHTTP: ' + JSON.stringify(status))
        console.log('------------------------------------------------')
        console.log('statusCielo: ' + JSON.stringify(result.Payment.Status))
        console.log('------------------------------------------------')
        console.log('result: ' + JSON.stringify(result))
      })
      .catch((error) => {
        console.log("erro:: " + error.message)
      })

  }


  capture () {
    this._cieloService.captureCieloPIX(4, '1234567890')
      .then((result) => {
        console.log(result)
      })
      .catch((err) => {
        console.log(err.message)
      })
  }

  async _capture (amount: number) {

    await this.captureCieloPIX(amount, '12345789')
      .then(async (result) => {
        console.log(result)
      })
      .catch((err) => {
        console.log(err.message)
      })

  }

  async captureCieloPIX (amount: number, link: string) {

    let countReturn: number = 0;

    const loopPromise = new Promise(async (resolve, reject) => {

      const ref = setInterval(async () => {

        if (countReturn >= amount) {
          clearInterval(ref);
          console.log('loopPromise FIM!')
          resolve('FIM!')
        } else {
          countReturn = await this.capturePIX(link, countReturn)
        }
      }, 2000)

    })

    return Promise.resolve(loopPromise);
  }

  async capturePIX (uri: string, count: number) {
    console.log(uri + " - " + count + " - " + new Date().toString())
    return (Number(count) + Number(1));
  }

}
